<aims-side-menu [component]="permissions.ComponentID.Permissions">
  <ng-template>
    <aims-side-menu-header [displayText]="'User Permissions'">
      <aims-side-menu-link [route]="'./'"
                           [component]="permissions.ComponentID.PermissionsDashboard"
                           [iconClass]="'fas fa-tachometer-alt'">
        Permissions Dashboard
      </aims-side-menu-link>
    </aims-side-menu-header>
    <aims-side-menu-header [displayText]="'Permissions Admin'">
      <aims-side-menu-link [route]="'./manageUsers'"
                           [component]="permissions.ComponentID.AIMSUsers"
                           [iconClass]="'fas fa-users-cog'">
        Manage Users
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./userPermissions'"
                           [component]="permissions.ComponentID.UserPermissions"
                           [iconClass]="'fas fa-key'">
        User Permissions
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./groupPermissions'"
                           [component]="permissions.ComponentID.GroupPermissions"
                           [iconClass]="'fas fa-users'">
        Group Permissions
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./componentRegistration'"
                           [component]="permissions.ComponentID.ComponentRegistration"
                           [iconClass]="'fas fa-thumbs-up'">
        Component Registration
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./permissionsReport'"
                           [component]="permissions.ComponentID.PermissionsReport"
                           [iconClass]="'fas fa-universal-access'">
        Permissions Report
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./componentReport'"
                           [component]="permissions.ComponentID.ComponentReport"
                           [iconClass]="'fas fa-object-group'">
        Component Report
      </aims-side-menu-link>
    </aims-side-menu-header>
  </ng-template>
</aims-side-menu>
